module.exports = __webpack_public_path__ + "img/img-info-img-s2.eb959e3d.jpg";